import { computed } from '@angular/core';
import { AccountDto } from '@api/core';
import { signalStoreFeature, type, withComputed, withFeature, withMethods } from '@ngrx/signals';
import { NotificationService } from '@shared/services/notifications/notifications.service';
import { useAssets } from '../assets.feature';
import { useLiquidityProviders } from '../liquidity-providers.feature';
import { usePairs } from '../pairs.feature';
import { useRoutes } from '../routes.feature';
import { useReferralAgents } from './referral-agents.feature';
import { useTopOfBook } from './top-of-book.feature';
import { useTransferInstructions } from './transfer-instructions.feature';

export const useSharedSettings = () =>
  signalStoreFeature(
    {
      props: {
        _notificationService: type<NotificationService>(),
      },
      state: {
        accounts: type<AccountDto[]>(),
      },
      methods: type<{
        loadAccounts: () => void;
      }>(),
    },
    withFeature(useLiquidityProviders),
    withFeature(usePairs),
    withFeature(useAssets),
    withFeature(useRoutes),
    withFeature(useTransferInstructions),
    withFeature(useReferralAgents),
    withFeature(useTopOfBook),
    withComputed(store => {
      const krakenPairs = computed(() =>
        store.lpPairs().filter(pair => pair.liquidityProviderId === store.krakenLp()?.id),
      );

      const bybitPairs = computed(() =>
        store.lpPairs().filter(pair => pair.liquidityProviderId === store.bybitLp()?.id),
      );

      return {
        krakenPairs,
        bybitPairs,
      };
    }),
    withMethods(store => {
      const getLpPairsByMarketMakingBasePair = (basePairId?: number) =>
        store.lpPairs().filter(lp => lp.basePairId === basePairId);

      return {
        getLpPairsByMarketMakingBasePair,
      };
    }),
  );
